import type { SxProps, Theme } from '@mui/material/styles';
import { navigationTokens } from '@peritasai/ui-shared';

export const navbarTitleContainerStyle = {
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem',
  paddingLeft: '0',
  paddingRight: '0',
};

export const navbarTitleStyle = {
  color: '#000000 !important',
  fontWeight: '500 !important',
  fontSize: '1rem !important',
  lineHeight: '150% !important',
  letterSpacing: '0.0094rem !important',
  textTransform: 'capitalize' as const,
  fontFamily: '"Helvetica Neue", "Roboto", "Arial", sans-serif',
  margin: '0',
};

export const navbarProjectTitleStyle = {
  color: navigationTokens.title,
  fontFeatureSettings: '"liga" off, "clig" off',
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '0.15px',
  margin: '0',
};

export const searchFieldSx: SxProps<Theme> = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: navigationTokens.search.surface,
    height: '2.9375rem',
    borderRadius: '1.5rem',
    boxSizing: 'border-box',
    padding: '12px 28px',
    color: navigationTokens.search.text,
    '& fieldset': {
      borderColor: 'transparent',
      borderWidth: '0.0625rem',
    },
    '&:hover fieldset': {
      borderColor: navigationTokens.search.borderHover,
    },
    '&.Mui-focused fieldset': {
      borderColor: navigationTokens.search.borderFocus,
    },
  },
  '& .MuiInputAdornment-positionStart': {
    marginLeft: '0px',
    marginRight: '8px',
  },
  '& .MuiInputAdornment-root .MuiSvgIcon-root': {
    color: navigationTokens.search.icon,
  },
  '& .MuiInputBase-input': {
    fontSize: '0.875rem',
    color: navigationTokens.search.text,
    '&::placeholder': {
      color: navigationTokens.search.placeholder,
      opacity: 1,
    },
  },
};

export const popperPaperSx = {
  mt: 1,
  width: '39.23vw',
  borderRadius: '0.75rem',
  overflow: 'hidden',
  py: '8px',
};

export const popperTitleSx = {
  color: 'rgba(0, 0, 0, 0.38)',
  fontFeatureSettings: '"liga" off, "clig" off',
  fontFamily: '"Helvetica Neue", "Roboto", "Arial", sans-serif',
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: '0.4px',
  margin: '0px',
};
